export default __webpack_public_path__ + "static/media/004-plane.e1043d47.svg";